import React, { useEffect, useMemo, useState } from 'react'
import { Autocomplete, CircularProgress, TextField } from '@mui/material'
import { useDebounce } from 'use-debounce'
import api from 'utils/api'

export default function AdminBusinessSelect({ value, onChange, allowAll = false, label = 'Business', error, helperText }) {
  const [input, setInput] = useState('')
  const [debouncedInput] = useDebounce(input, 250)
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let current = true
    setLoading(true)
    api.get(`/admin/businesses?q=${encodeURIComponent(debouncedInput)}&size=20&sort=name,asc`)
      .then(data => { if (current) setOptions(data?.content || []) })
      .catch(() => { if (current) setOptions([]) })
      .finally(() => { if (current) setLoading(false) })
    return () => { current = false }
  }, [debouncedInput])

  const selected = useMemo(() => {
    if (!value) return null
    return options.find(option => String(option.businessId) === String(value)) || {
      businessId: Number(value), name: `Business ${value}`,
    }
  }, [options, value])

  return <Autocomplete
    value={selected}
    options={options}
    loading={loading}
    isOptionEqualToValue={(option, selectedOption) => String(option.businessId) === String(selectedOption.businessId)}
    getOptionLabel={option => option?.name || `Business ${option?.businessId}`}
    onChange={(_, option) => onChange(option?.businessId ? String(option.businessId) : '')}
    onInputChange={(_, next, reason) => { if (reason === 'input' || reason === 'clear') setInput(next) }}
    disableClearable={!allowAll}
    renderInput={params => <TextField {...params} size="small" label={label} error={error} helperText={helperText}
      InputProps={{ ...params.InputProps, endAdornment: <>{loading && <CircularProgress size={18} />}{params.InputProps.endAdornment}</> }} />}
  />
}
